export default "__VITE_ASSET__ClcmTuDA__"